import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { COMMANDS } from "../../../mod-command/constants";
import { sendCommand } from "../../../mod-command/slice";
import Dialog from "../../../base/ui/components/web/Dialog";
import { Trans, useTranslation } from "react-i18next";
import { getParticipantById } from "../../../base/participants";
const DialogPinAllParticipants = ({ exclude, participantId }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const particpant = useSelector((state) => getParticipantById(state, participantId));
    const [title, setTitle] = useState(t("dialog.pinAllParticipants.title"));
    const [content, setContent] = useState(t("dialog.pinAllParticipants.content", { who: particpant?.name }));
    const onSubmit = () => {
        dispatch(sendCommand(COMMANDS.PIN_PARTICIPANT.COMMAND, participantId, true));
    };
    return (React.createElement(Dialog, { ok: { translationKey: "dialog.pinAllParticipants.confirm" }, onSubmit: onSubmit, title: title },
        React.createElement("div", { className: "mute-dialog" },
            React.createElement(Trans, { i18nKey: "dialog.pinAllParticipants.content", values: { who: particpant?.name } }))));
};
export default DialogPinAllParticipants;
